import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LifeBuoy } from "lucide-react";
import { api } from "../../lib/api";
import { fmtDuration } from "../../pages/SavDashboardPage";

export default function SavOverviewCard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/sav/stats", { params: { period: "30d" } }).then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const items = [["open", "SAV ouverts", d.open, ""], ["late", "En retard (relance 2-3)", d.late, d.late ? "text-amber-700" : ""],
    ["reassign", "À réattribuer", d.to_reassign, d.to_reassign ? "text-red-700" : ""], ["takeover", "Prise en charge moy. (30 j)", fmtDuration(d.avg_takeover_h), ""],
    ["resolution", "Résolution moy. (30 j)", fmtDuration(d.avg_resolution_h), ""]];
  return (
    <Link to="/sav/tableau-de-bord" className="block bg-white border border-norea-border rounded-md p-4 mb-6 hover:border-norea-primary/50 transition-colors" data-testid="overview-sav-card">
      <div className="flex items-center justify-between mb-2">
        <span className="font-heading text-base font-medium inline-flex items-center gap-2"><LifeBuoy className="w-4 h-4 text-norea-primary" />Service après-vente</span>
        <span className="text-[11px] text-norea-textMuted">Tableau de bord SAV →</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {items.map(([k, l, v, tone]) => (
          <div key={k}><div className="text-[11px] text-norea-textMuted">{l}</div><div className={`text-xl font-heading tabular-nums ${tone}`} data-testid={`overview-sav-${k}`}>{v}</div></div>
        ))}
      </div>
    </Link>
  );
}
